import { Button } from "@mui/material";
import RightArrow from "../Vectors/RightArrow";
import { isValidCpf, isValidEmail } from "../../services/UtilsService";

const DelendForgotPasswordButton = (props) => {
  const enableButton = (props) => {
    return (
      props.user &&
      props.user.username &&
      (isValidEmail(props.user.username) || isValidCpf(props.user.username))
    );
  };

  const btnStyle = {
    background: "#503DFC",
    textTransform: "none",
    borderRadius: 50,
    textUnderlineOffset: "10px",
    "&.Mui-disabled": {
      background: "#7363FF",
      opacity: 1,
      color: "#fff",
    },
    "&.MuiButtonBase-root:hover": {
      bgcolor: "#503DFC",
    },
  };

  return (
    <Button
      onClick={props.onClick}
      type="submit"
      disabled={!enableButton(props)}
      variant="contained"
      sx={btnStyle}
      fullWidth
      endIcon={<RightArrow></RightArrow>}
    >
      Solicitar recuperação de senha
    </Button>
  );
};

export default DelendForgotPasswordButton;
